import { useEffect } from "react";
import LegalShell from "@/components/masar/LegalShell";
import PrivacyContent from "@/components/masar/PrivacyContent";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Privacy() {
  const { t } = useLanguage();
  useEffect(() => {
    document.title = `MASAR — ${t("legal.privacyTitle")}`;
  }, [t]);
  return (
    <LegalShell title={t("legal.privacyTitle")} updated={t("legal.updated")}>
      <PrivacyContent />
    </LegalShell>
  );
}
